export const shadows = {
  sm: '0px 0px 10px rgba(216, 222, 235, 0.5)',
  md: '0px 0px 20px rgba(97, 108, 137, 0.3)',
  lg: '0px 0px 50px rgba(97, 108, 137, 0.4)',
}
